import React, { useState } from 'react';
import CommonHeader from '@/components/CommonHeader';
import $i18n from '@/i18n';
// import { Form } from 'antd';
import { Icon, Message, Input, Radio, Form, Modal } from '@b-design/fusion';
import { Field, Dialog } from '@alifd/next';
import styles from './index.module.less';
// import InviteModal from '../invite';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';
import Button, { promisifyValidate } from '@/components/Button';

// TODO
const breadcrumbConfig = [
  {
    key: 'invitation',
    breadcrumbName: $i18n.get({ id: 'aopf.pages.invitation.thirdParty', dm: '三方伙伴邀请' }),
    path: '/invitation',
  },
];

interface Props {
  queryInvitations?: any;
  setPaginationValue?: any;
}

const Header: React.FC<Props> = ({ queryInvitations, setPaginationValue }) => {
  const field = Field.useField();
  const { init, getValue, getError } = field;

  const { spaceId } = getQueryStringArgs();
  // 邀请弹框
  const [inviteVisible, setInviteVisible] = useState<boolean>(false);

  const onInviteClose = () => {
    setInviteVisible(false);
    // form?.resetFields();
  };

  const onFinish = async () => {
    const [errs, vals] = await promisifyValidate(field);
      if (errs) {
        return;
      }
      const params = {
        inviteEmail: getValue('inviteEmail'),
        invitee: getValue('invitee'),
        validDate: 1,
        type: 'SPACE_CREATE',
        spaceId,
      };
      try {
      const data = await Requests.post('/rest/intercnn/invitation/create', params, {}, true)
          if (data) {
            Message.success({
              title: $i18n.get({
                id: 'aopf.pages.invitation.invited.message.success',
                dm: '邀请成功',
              }),
            });
            onInviteClose();
            queryInvitations({ spaceId, currentPage: 1, pageSize: 10, type: 'SPACE_CREATE' });
            setPaginationValue({
              currentPage: 1,
              pageSize: 10,
            });
          } else {
            Message.error({
              title: $i18n.get({
                id: 'aopf.pages.channel.channelList.message.error',
                dm: '系统出错，稍后重试',
              }),
            });
          }
        } catch(error){
          if (error?.errorCode === 'INTCNN_THIRD_SPACE_NUM_LIMIT') {
            Modal.error({
              title: $i18n.get({
                id: 'aopf.components.CreateMiniappDrawer.InvitationFailed',
                dm: '邀请失败',
              }),
              content: $i18n.get({
                id: 'aopf.components.CreateMiniappDrawer.TheMaximumInvitationValueHas',
                dm: '已达到最大邀请值',
              }),
              footer: null,
            });
          } else {
            Message.error(
              error?.Detail ||
                error?.errorMsg ||
                $i18n.get({
                  id: 'aopf.pages.channel.channelList.message.error',
                  dm: '系统出错，稍后重试',
                }),
            );
          }
        };

    // const last=values || {} ;
  };

  return (
    <div className={styles.inviteContainer}>
      <CommonHeader
        title={$i18n.get({ id: 'aopf.pages.invitation.thirdParty', dm: '三方伙伴邀请' })}
        // backTo={`/overview${location.search}`}
        breadcrumbs={breadcrumbConfig}
      />

      <div className={styles.inviteAddBtn}>
        <Button type="primary" data-child-type="icon-text" onClick={() => setInviteVisible(true)}>
          <Icon type="add--circle--filled" />
          {$i18n.get({ id: 'aopf.pages.invitation.invite', dm: '邀请' })}
        </Button>
      </div>

      {/* 增加成员 */}
      <Dialog
        v2
        title={$i18n.get({ id: 'aopf.pages.invitation.invite', dm: '邀请' })}
        visible={inviteVisible}
        // TODO
        onOk={onFinish}
        onClose={onInviteClose}
        footerActions={['cancel', 'ok']}
        width={848}
        className="modal-addMember"
        footer={[
          <div className="dialog-footer">
            <Button className="dialog-btn" type="normal" onClick={onInviteClose}>
              {$i18n.get({ id: 'aopf.component.invite.Cancel', dm: '取消' })}
            </Button>
            <Button type="primary" onClick={onFinish}>
              {$i18n.get({ id: 'aopf.component.invite.Ok', dm: '确定' })}
            </Button>
          </div>,
        ]}
      >
        <Form
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          labelAlign={'left'}
          labelTextAlign={'left'}
        >
          <Form.Item
            label={$i18n.get({ id: 'aopf.pages.member.addMemberName', dm: '名称' })}
            name="invitee"
            required
          >
            <Input
              placeholder={$i18n.get({
                id: 'aopf.pages.invitation.inputInvitee.placeholder',
                dm: '输入具有2-36个字符的名称。',
              })}
              style={{ width: '450px' }}
              {...init('invitee', {
                initValue: '',
                rules: {
                  required: true,
                  minLength: 2,
                  maxLength: 36,
                  message: $i18n.get({
                    id: 'aopf.pages.invitation.inputInvitee.rules',
                    dm: '请输入具有2-36个字符的名称。',
                  }),
                },
              })}
            />

            <p style={{ fontSize: 12, color: '#c82727' }}>{getError('invitee')}</p>
          </Form.Item>

          <Form.Item
            label={$i18n.get({ id: 'aopf.pages.member.addMemberEmail', dm: '邮箱' })}
            name="inviteEmail"
            required
          >
            <Input
              placeholder={$i18n.get({
                id: 'aopf.pages.invitation.Email.Address.characters',
                dm: 'example@email.com.',
              })}
              style={{ width: '450px' }}
              {...init('inviteEmail', {
                initValue: '',
                rules: [
                  {
                    required: true,
                    pattern: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,}$/,
                    message: $i18n.get({
                      id: 'aopf.pages.miniapp.drawer.form.email.msg',
                      dm: '请输入正确的邮箱',
                    }),
                  },
                ],
              })}
            />

            <p style={{ fontSize: 12, color: '#c82727' }}>{getError('inviteEmail')}</p>
          </Form.Item>

          <Form.Item
            label={$i18n.get({
              id: 'aopf.pages.space.InvitationValidity',
              dm: '邀请有效期',
            })}
            name="validDate"
            required
          >
            <Radio.Group defaultValue={1}>
              <Radio value={1}>
                <span className="days">
                  {$i18n.get({
                    id: 'aopf.pages.member.addMemberInvitationValidityItem',
                    dm: '24小时',
                  })}
                </span>
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
      </Dialog>
    </div>
  );
};
export default Header;
